import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Form, Input, Button, Checkbox, Card, Row, Col, Space, Divider } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { getAuthToken, isTokenExpired, getUserType, logout } from "../../utility/auth";
import LogoImage from "../../assets/logo.png";



export default function Login() {
    const [uname, unamechange] = useState("");
    const [pass, passchange] = useState("");
    const [keepLoggedIn, setKeepLoggedIn] = useState(false); // State for "Keep Me Logged In"
    const navigate = useNavigate();
const handleSubmit = (values) => {
  const empdata = { uname: values.uname, pass: values.pass };

  axios.post("/login", empdata)
    .then((res) => {
      if (res.status === 200) {
        const data = res.data;
        if (data.token) {
          const token = data.token;
          const usertype = data.data.type.toLowerCase(); // Normalize to lowercase
          const expirationTime = Date.now() + 3 * 60 * 60 * 1000; // 3 hours

          if (keepLoggedIn) {
            localStorage.setItem("token", token);
            localStorage.setItem("expirationTime", expirationTime);
            localStorage.setItem("uname", data.data.uname);
            localStorage.setItem("usertype", usertype); // Store normalized usertype
          } else {
            sessionStorage.setItem("token", token);
            sessionStorage.setItem("expirationTime", expirationTime);
            sessionStorage.setItem("uname", data.data.uname);
            sessionStorage.setItem("usertype", usertype); // Store normalized usertype
          }

          toast.success("Logged in Successfully");

          // Add delay before redirect
          setTimeout(() => {
            console.log("Redirecting user with type:", usertype); // Debug log
            if (usertype === "admin") {
              navigate("/dashboard/analytics", { replace: true });
            } else if (usertype === "account") {
              navigate("/dashboard/account", { replace: true });
            } else if (usertype === "cashier") {
              navigate("/dashboard/cashier", { replace: true }); // Use existing cashier dashboard
            } else if (usertype === "manager") {
              navigate("/dashboard/admin", { replace: true }); // Redirect managers to admin dashboard
            } else if (usertype === "gate operation") {
              navigate("/gate/scan", { replace: true });
            } else {
              console.warn("Unknown user type:", usertype);
              navigate("/dashboard/admin", { replace: true }); // Default fallback to admin dashboard
            }
          }, 1000); // Increased delay

        } else {
          toast.error("Wrong username/Password");
        }
      } else if (res.status === 401) {
        toast.error("Wrong username/Password");
      }
    })
    .catch((err) => {
      toast.error("Wrong username/Password");
      console.log(err.message);
    });
};
useEffect(() => {
  const token = getAuthToken();
  const userType = getUserType();
  console.log("Token:", token);
  console.log("Is expired:", isTokenExpired());
  console.log("User type:", userType);

  if (token && !isTokenExpired()) {
    const normalizedUserType = userType?.toLowerCase();
    console.log("Normalized user type:", normalizedUserType);
    
    switch (normalizedUserType) {
      case "admin":
        navigate("/dashboard/analytics", { replace: true });
        break;
      case "account":
        navigate("/dashboard/account", { replace: true });
        break;
      case "cashier":
        navigate("/dashboard/cashier", { replace: true }); // Use existing cashier dashboard
        break;
      case "manager":
        navigate("/dashboard/analytics", { replace: true }); // Redirect managers to analytics dashboard
        break;
            case "gate operation":
                navigate("/gate/scan", { replace: true });
                break;
      default:
        console.warn("Unknown user type, staying on login");
        logout(); // Clear invalid session
        break;
    }
  }
}, [navigate]);

    return (
        <>
            <ToastContainer position="top-right" />
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #1a1f35 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                fontFamily: 'Segoe UI, Roboto, sans-serif',
                position: 'relative',
                overflow: 'hidden'
            }}>
                {/* 3D Glow Background Elements */}
                <div style={{
                    position: 'absolute',
                    top: '-20%',
                    right: '-10%',
                    width: '800px',
                    height: '800px',
                    background: 'radial-gradient(circle, rgba(220, 38, 38, 0.35) 0%, rgba(251, 191, 36, 0.15) 40%, transparent 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none',
                    filter: 'blur(80px)',
                    animation: 'glow3d 8s ease-in-out infinite'
                }} />
                <div style={{
                    position: 'absolute',
                    bottom: '-30%',
                    left: '-15%',
                    width: '700px',
                    height: '700px',
                    background: 'radial-gradient(circle, rgba(100, 200, 255, 0.3) 0%, rgba(217, 119, 6, 0.15) 50%, transparent 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none',
                    filter: 'blur(80px)',
                    animation: 'glow3d-alt 8s ease-in-out infinite'
                }} />
                <div style={{
                    position: 'absolute',
                    top: '-5%',
                    left: '-15%',
                    width: '600px',
                    height: '600px',
                    background: 'radial-gradient(circle, rgba(139, 92, 246, 0.25) 0%, transparent 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none',
                    filter: 'blur(70px)',
                    animation: 'glow3d 10s ease-in-out infinite 2s'
                }} />
                <div style={{
                    position: 'absolute',
                    bottom: '10%',
                    right: '-12%',
                    width: '550px',
                    height: '550px',
                    background: 'radial-gradient(circle, rgba(59, 130, 246, 0.28) 0%, transparent 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none',
                    filter: 'blur(70px)',
                    animation: 'glow3d-alt 9s ease-in-out infinite 1s'
                }} />
                <div style={{
                    position: 'absolute',
                    top: '30%',
                    right: '5%',
                    width: '500px',
                    height: '500px',
                    background: 'radial-gradient(circle, rgba(251, 191, 36, 0.2) 0%, transparent 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none',
                    filter: 'blur(75px)',
                    animation: 'glow3d 12s ease-in-out infinite 0.5s'
                }} />

                <Row gutter={[32, 32]} style={{ width: '100%', maxWidth: '1200px', position: 'relative', zIndex: 1 }}>
                    {/* Left Section - Form */}
                    <Col xs={24} md={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Card
                            style={{
                                width: '100%',
                                maxWidth: '450px',
                                borderRadius: '16px',
                                border: '2px solid #dc2626',
                                boxShadow: '0 25px 80px rgba(0, 0, 0, 0.6), 0 0 40px rgba(220, 38, 38, 0.2)',
                                padding: '40px',
                                background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
                                backdropFilter: 'blur(10px)'
                            }}
                            bodyStyle={{ padding: 0 }}
                        >
                            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                                {/* Logo & Title */}
                                <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                    <div style={{
                                        width: '200px',
                                        height: '200px',
                                        margin: '0 auto 25px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '20px',
                                        background: 'transparent',
                                        boxShadow: `
                                            0 0 20px rgba(251, 191, 36, 0.4),
                                            0 0 40px rgba(220, 38, 38, 0.3),
                                            0 0 60px rgba(251, 191, 36, 0.2),
                                            0 0 80px rgba(100, 200, 255, 0.15),
                                            0 12px 48px rgba(220, 38, 38, 0.2),
                                            inset 0 0 30px rgba(251, 191, 36, 0.1)
                                        `,
                                        padding: '10px',
                                        animation: 'logoGlow 3s ease-in-out infinite'
                                    }}>
                                        <img
                                            src={LogoImage}
                                            alt="THE VIEW PATTAYA"
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                filter: 'drop-shadow(0 6px 12px rgba(0, 0, 0, 0.3))'
                                            }}
                                        />
                                    </div>
                                    <p style={{
                                        fontSize: '1rem',
                                        color: '#94a3b8',
                                        fontWeight: '500',
                                        margin: 0
                                    }}>Amusement Park Management System</p>
                                </div>

                                <Divider style={{ margin: '10px 0' }} />

                                {/* Login Form */}
                                <Form
                                    layout="vertical"
                                    onFinish={handleSubmit}
                                    autoComplete="off"
                                >
                                    <Form.Item
                                        label={<span style={{ fontWeight: '600', color: '#fbbf24' }}>User ID</span>}
                                        name="uname"
                                        rules={[{ required: true, message: 'Please enter your username' }]}
                                    >
                                        <Input
                                            prefix={<UserOutlined style={{ color: '#dc2626' }} />}
                                            placeholder="Enter your username"
                                            size="large"
                                            style={{
                                                borderRadius: '10px',
                                                border: '2px solid rgba(220, 38, 38, 0.4)',
                                                fontSize: '1rem',
                                                background: '#0f172a',
                                                color: '#e2e8f0',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onFocus={(e) => {
                                                e.currentTarget.style.borderColor = '#dc2626';
                                                e.currentTarget.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.15)';
                                            }}
                                            onBlur={(e) => {
                                                e.currentTarget.style.borderColor = 'rgba(220, 38, 38, 0.4)';
                                                e.currentTarget.style.boxShadow = 'none';
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        label={
                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                <span style={{ fontWeight: '600', color: '#fbbf24' }}>Password</span>
                                                <Link to="/forgot-password" style={{ color: '#94a3b8', fontSize: '0.85rem', transition: 'color 0.3s' }} onMouseEnter={(e) => e.target.style.color = '#dc2626'} onMouseLeave={(e) => e.target.style.color = '#94a3b8'}>
                                                    Forgot password?
                                                </Link>
                                            </div>
                                        }
                                        name="pass"
                                        rules={[{ required: true, message: 'Please enter your password' }]}
                                    >
                                        <Input.Password
                                            prefix={<LockOutlined style={{ color: '#dc2626' }} />}
                                            placeholder="Enter your password"
                                            size="large"
                                            style={{
                                                borderRadius: '10px',
                                                border: '2px solid rgba(220, 38, 38, 0.4)',
                                                fontSize: '1rem',
                                                background: '#0f172a',
                                                color: '#e2e8f0',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onFocus={(e) => {
                                                const input = e.currentTarget.querySelector('input');
                                                if (input) {
                                                    e.currentTarget.style.borderColor = '#dc2626';
                                                    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.15)';
                                                }
                                            }}
                                            onBlur={(e) => {
                                                const input = e.currentTarget.querySelector('input');
                                                if (input) {
                                                    e.currentTarget.style.borderColor = 'rgba(220, 38, 38, 0.4)';
                                                    e.currentTarget.style.boxShadow = 'none';
                                                }
                                            }}
                                        />
                                    </Form.Item>

                                    <Form.Item name="remember">
                                        <Checkbox
                                            checked={keepLoggedIn}
                                            onChange={() => setKeepLoggedIn(!keepLoggedIn)}
                                            style={{ color: '#cbd5e1', fontWeight: '500' }}
                                        >
                                            Keep me logged in
                                        </Checkbox>
                                    </Form.Item>

                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            size="large"
                                            block
                                            style={{
                                                background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
                                                border: 'none',
                                                borderRadius: '10px',
                                                fontSize: '1.05rem',
                                                fontWeight: '700',
                                                height: '48px',
                                                letterSpacing: '0.5px',
                                                boxShadow: '0 8px 20px rgba(220, 38, 38, 0.4)',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.boxShadow = '0 12px 30px rgba(220, 38, 38, 0.5)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(220, 38, 38, 0.4)';
                                            }}
                                        >
                                            🎢 ENTER PARK
                                        </Button>
                                    </Form.Item>
                                </Form>
                            </Space>
                        </Card>
                    </Col>

                    {/* Right Section - Features */}
                    <Col xs={24} md={12} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ width: '100%' }}>
                            <h2 style={{
                                fontSize: '2.2rem',
                                fontWeight: '800',
                                color: '#fbbf24',
                                marginBottom: '15px',
                                textShadow: '0 2px 8px rgba(0,0,0,0.5)'
                            }}>
                                🎪 Welcome to the Fun Zone! 🎠
                            </h2>
                            <p style={{
                                fontSize: '1.1rem',
                                color: '#cbd5e1',
                                marginBottom: '35px',
                                fontWeight: '500',
                                lineHeight: '1.6'
                            }}>
                                Manage your amusement park operations with ease. Access ticketing, billing, and gate management systems.
                            </p>

                            <Space direction="vertical" size="large" style={{ width: '100%' }}>
                                {[
                                    { icon: '🎫', title: 'Smart Ticketing', desc: 'Digital tickets & fast entry' },
                                    { icon: '💳', title: 'Easy Billing', desc: 'POS & payment management' },
                                    { icon: '🚪', title: 'Gate Control', desc: 'Entry & security management' },
                                    { icon: '📊', title: 'Analytics', desc: 'Real-time reporting & insights' }
                                ].map((feature, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '16px',
                                        padding: '16px',
                                        background: 'rgba(220, 38, 38, 0.08)',
                                        borderRadius: '12px',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(220, 38, 38, 0.2)',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(220, 38, 38, 0.12)';
                                        e.currentTarget.style.borderColor = 'rgba(220, 38, 38, 0.4)';
                                        e.currentTarget.style.transform = 'translateX(8px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'rgba(220, 38, 38, 0.08)';
                                        e.currentTarget.style.borderColor = 'rgba(220, 38, 38, 0.2)';
                                        e.currentTarget.style.transform = 'translateX(0)';
                                    }}
                                    >
                                        <div style={{
                                            fontSize: '2rem',
                                            minWidth: '50px',
                                            textAlign: 'center'
                                        }}>
                                            {feature.icon}
                                        </div>
                                        <div>
                                            <h4 style={{
                                                margin: '0 0 4px 0',
                                                fontSize: '1rem',
                                                fontWeight: '700',
                                                color: '#fbbf24'
                                            }}>
                                                {feature.title}
                                            </h4>
                                            <p style={{
                                                margin: 0,
                                                fontSize: '0.9rem',
                                                color: '#cbd5e1'
                                            }}>
                                                {feature.desc}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </Space>
                        </div>
                    </Col>
                </Row>

                {/* Footer */}
                <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(180deg, rgba(15, 23, 42, 0) 0%, rgba(15, 23, 42, 0.95) 100%)',
                    backdropFilter: 'blur(10px)',
                    borderTop: '1px solid rgba(220, 38, 38, 0.1)',
                    padding: '24px 20px 20px 20px',
                    textAlign: 'center',
                    zIndex: 100
                }}>
                    <div style={{
                        maxWidth: '1200px',
                        margin: '0 auto'
                    }}>
                        <p style={{
                            margin: '0 0 8px 0',
                            fontSize: '0.85rem',
                            color: '#cbd5e1',
                            fontWeight: '500'
                        }}>
                            🚀 Designed and Developed by <span style={{ color: '#fbbf24', fontWeight: '700' }}>Cloudnet Softwares Co. Ltd</span>
                        </p>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '20px',
                            flexWrap: 'wrap',
                            marginTop: '8px'
                        }}>
                            <a href="tel:+66948712350" style={{
                                fontSize: '0.8rem',
                                color: '#94a3b8',
                                textDecoration: 'none',
                                transition: 'color 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
                            onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                            >
                                📞 Support: +66-948712350
                            </a>
                            <span style={{ color: '#475569' }}>•</span>
                            <a href="mailto:info@cloudnetsoftwares.com" style={{
                                fontSize: '0.8rem',
                                color: '#94a3b8',
                                textDecoration: 'none',
                                transition: 'color 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#fbbf24'}
                            onMouseLeave={(e) => e.target.style.color = '#94a3b8'}
                            >
                                ✉️ info@cloudnetsoftwares.com
                            </a>
                        </div>
                    </div>
                </div>

                <style jsx>{`
                    @keyframes logoGlow {
                        0%, 100% {
                            box-shadow:
                                0 0 20px rgba(251, 191, 36, 0.4),
                                0 0 40px rgba(220, 38, 38, 0.3),
                                0 0 60px rgba(251, 191, 36, 0.2),
                                0 0 80px rgba(100, 200, 255, 0.15),
                                0 12px 48px rgba(220, 38, 38, 0.2);
                        }
                        50% {
                            box-shadow:
                                0 0 30px rgba(251, 191, 36, 0.6),
                                0 0 50px rgba(220, 38, 38, 0.4),
                                0 0 80px rgba(251, 191, 36, 0.3),
                                0 0 100px rgba(100, 200, 255, 0.25),
                                0 12px 48px rgba(220, 38, 38, 0.3);
                        }
                    }

                    @keyframes glow3d {
                        0%, 100% {
                            opacity: 0.6;
                            transform: scale(1) translate(0, 0);
                        }
                        25% {
                            opacity: 0.8;
                            transform: scale(1.05) translate(15px, -10px);
                        }
                        50% {
                            opacity: 1;
                            transform: scale(1.15) translate(20px, 15px);
                        }
                        75% {
                            opacity: 0.8;
                            transform: scale(1.05) translate(10px, 8px);
                        }
                    }

                    @keyframes glow3d-alt {
                        0%, 100% {
                            opacity: 0.5;
                            transform: scale(0.9) translate(0, 0);
                        }
                        25% {
                            opacity: 0.75;
                            transform: scale(1) translate(-15px, 10px);
                        }
                        50% {
                            opacity: 0.95;
                            transform: scale(1.1) translate(-20px, 15px);
                        }
                        75% {
                            opacity: 0.75;
                            transform: scale(1) translate(-10px, 8px);
                        }
                    }

                    @media (max-width: 768px) {
                        .ant-card {
                            padding: 30px !important;
                        }
                    }
                `}</style>
            </div>
        </>
    );
}
